'user strict';

import { createSelector } from 'reselect';

export const getList = ({ locationList }) => locationList.list;

export const getListDate = ({ locationList }) => locationList.date;

export const getLastUpdate = ({ locationList }) => locationList.lastUpdate;

export const getSelected = createSelector(
	[ getList ],
	list => list.filter(i => i.isChecked)
);

export const getSelectedIndices = createSelector(
	[ getList ],
	list => list.reduce(
		(indices, item, i) => item.isChecked ? [ ...indices, i ] : indices,
		[]
	)
);

export const getSelectedLength = createSelector(
	[ getSelected ],
	selected => selected.length
);

export const someAreSelected = createSelector(
	[ getSelectedLength ],
	length => !!length
);

export const selectedAreConsecutive = createSelector(
	[ getList, getSelectedLength ],
	(list, selectedLength) => {

		const firstIdx = list.findIndex(item => item.isChecked);
		const lastIdx = list.findLastIndex(item => item.isChecked);

		if (firstIdx > -1) {
			if (firstIdx === lastIdx) {
				return false;
			}

			return (lastIdx - firstIdx + 1) === selectedLength;
		}

		return false;
	}
);

export const getActionBtns = createSelector(
	[ getSelected, getSelectedLength, someAreSelected, selectedAreConsecutive ],
	(selected, selectedLength, someSelected, areConsecutive) => ({
		deleteJobs: someSelected,
		moveUp: someSelected,
		moveDown: someSelected,
		reverse: !someSelected || (selectedLength > 1 && areConsecutive),
		copyNextDay: someSelected,
		reroute: false,
		optimize: !someSelected || (
			selectedLength > 1 && selectedLength <= 25 &&
			areConsecutive
		),
	})
);

export const getListLength = createSelector(
	[ getList ],
	list => list.length
);

export const allAreSelected = createSelector(
	[ getListLength, getSelectedLength ],
	(listLength, selectedLength) => selectedLength && (listLength === selectedLength)
);
